import { formatJSON } from '../../utils/common';

const manualInitialState = {
  enabled: false,
  code: null,
};

const manual = (state = manualInitialState, action) => {
  switch (action.type) {
    case 'CHANGE_FUNNEL_MANUAL_CODE':
      return {
        ...state,
        code: formatJSON(action.code),
      };

    case 'FUNNEL_MANUAL_ENABLE':
      return {
        ...state,
        enabled: true,
      };

    case 'UPDATE_LOCATION':
      return manualInitialState;

    default:
      return state;
  }
};

export default manual;

export const isEnabled = (state) => state.enabled;

export const getCode = (state) => state.code;
